module.exports = __webpack_public_path__ + "img/instagram.4ab43793.png";